import { queryOptions } from '@tanstack/react-query';

import { ONE_HOUR } from '@/constants/time';
import { paths } from '@/types/api';
import { fetchClient } from '@/util/fetchClient';

type ResponseTimeSettingsPath = paths['/v2/response-time-settings']['get'];

type ResponseTimeSettingsResponse =
  ResponseTimeSettingsPath['responses']['200']['content']['application/json'];

type ResponseTimeSetting = NonNullable<ResponseTimeSettingsResponse['data']>[0];

/**
 * Fetches response time settings from the API and transforms them into the format expected by the ResponseTime component.
 */
export async function getResponseTimeSettingsV2() {
  const { data } = await fetchClient.GET('/v2/response-time-settings');

  const responseTimeSettings = data?.data || [];

  const responseTimeBuckets = responseTimeSettings.map((setting: ResponseTimeSetting) => ({
    label: setting.label,
    maxTime: setting.maxTime === null ? Infinity : Number(setting.maxTime),
  }));

  return responseTimeBuckets;
}

export const getResponseTimeSettingsV2QueryOptions = () =>
  queryOptions({
    queryKey: ['responseTimeSettingsV2'],
    queryFn: getResponseTimeSettingsV2,
    staleTime: ONE_HOUR,
    gcTime: ONE_HOUR,
  });
